import { Button, DialogActions, DialogContent } from '@mui/material';
import DialogAnimate, { Props as DialogProps } from 'src/components/animate/DialogAnimate';
import DialogTitleWithCloseButton from 'src/components/dialog/DialogTitleWithCloseButton';
import { useStores } from 'src/models';
import getLastUpdatedText from 'src/utils/getLastUpdatedText';

import ProjectForm, { IProjectFormProps } from './ProjectForm';

export interface IProjectFormModalProps extends DialogProps, IProjectFormProps {
  onDelete?: (projectSid: number) => Promise<void>;
}
/**
 * ## ProjectFormModal 설명
 */
function ProjectFormModal({
  open,
  formId,
  formType,
  project,
  onClose,
  onDelete,
  onComplete,
}: IProjectFormModalProps) {
  const formTypeText = () => {
    switch (formType) {
      case 'CREATE':
        return '등록';
      case 'UPDATE':
        return '수정';
      case 'READONLY':
        return '상세보기';
      default:
        return '';
    }
  };
  const { alertStore } = useStores();

  const handleDelete = async () => {
    if (!onDelete || !project?.projectSid) return;

    // on confirm alert
    alertStore.setOnConfirm(() => {
      onDelete(project.projectSid);
    });

    // open alert
    alertStore.setProps({
      open: true,
      title: '프로젝트 삭제',
      content: '해당 프로젝트를 삭제하시겠습니까?',
      category: 'error',
      hasCancelButton: true,
    });
  };

  return (
    <DialogAnimate fullWidth maxWidth="xl" open={open} scroll="paper">
      <DialogTitleWithCloseButton
        title={`프로젝트  ${formTypeText()}`}
        subtitle={project ? getLastUpdatedText(project.updUser.userNm, project.updDt) : ''}
        onClose={onClose}
      />
      {/* Form */}
      <DialogContent dividers>
        <ProjectForm
          formId={formId}
          formType={formType}
          project={project}
          onComplete={onComplete}
          readonly={formType === 'READONLY'}
        />
      </DialogContent>
      {formType !== 'READONLY' && (
        <DialogActions>
          {/* Delete Button */}
          {formType === 'UPDATE' && onDelete && (
            <Button onClick={handleDelete} variant="contained" color="error">
              삭제
            </Button>
          )}
          {/* Submit Button */}
          <Button type="submit" variant="contained" form={formId}>
            {formType === 'CREATE' ? '등록' : '수정'}
          </Button>
        </DialogActions>
      )}
    </DialogAnimate>
  );
}

export default ProjectFormModal;
